// Webpack entry point for module federation.
// This import needs to be kept with brackets.
import("./bundle");
